export * from './searchUtils';
export * from './fetchUtils';

import { FetchError } from './fetchUtils';

/**
 * Type guard to check if an error is a FetchError
 */
export function isFetchError(error: unknown): error is FetchError {
  return (
    error instanceof Error && 
    (error as FetchError).isApiError === true
  );
}

/**
 * Determines the appropriate error mapper source based on the error type
 */
export function getErrorMapperSource(error: unknown): string {
  if (isFetchError(error)) {
    return 'fetch';
  }
  
  return 'internal';
}